import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BadgeCheckIcon, XIcon } from "lucide-react";
import { recentBuyers } from "../data/content";
const FIRST_DELAY = 6000;
const SHOW_FOR = 5000;
const GAP = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [minutes, setMinutes] = useState(2);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    let nextTimer: number;
    const show = () => {
      setMinutes(1 + Math.floor(Math.random() * 9));
      setVisible(true);
      hideTimer = window.setTimeout(() => {
        setVisible(false);
        nextTimer = window.setTimeout(() => {
          setIndex(i => (i + 1) % recentBuyers.length);
          show();
        }, GAP);
      }, SHOW_FOR);
    };
    const start = window.setTimeout(show, FIRST_DELAY);
    return () => {
      window.clearTimeout(start);
      window.clearTimeout(hideTimer);
      window.clearTimeout(nextTimer);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <div className="pointer-events-none fixed bottom-24 left-3 right-3 z-50 flex md:bottom-6 md:left-6 md:right-auto" aria-live="polite" data-id="element-251" data-mp="1fviy7h1shfis">
      <AnimatePresence data-id="element-252" data-mp="1ay0mjiwe0m73">
        {visible && !dismissed && <motion.div key={buyer.name} initial={{
        opacity: 0,
        y: 12,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 12,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex w-full max-w-sm items-center gap-3 rounded-2xl bg-white p-3.5 pr-10 shadow-[0_12px_40px_-10px_rgba(28,10,46,0.35)] ring-1 ring-plum-100" data-id="element-253" data-mp="n6v5x1imhpvq">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-go/10 text-go" data-id="element-254" data-mp="23ld9hu6gmw0x">
              <BadgeCheckIcon className="h-6 w-6" aria-hidden data-id="element-255" data-mp="2ap2yj3htke80" />
            </span>
            <div className="min-w-0 text-sm leading-snug" data-id="element-256" data-mp="2fnnyr2x2mxwg">
              <p className="font-bold text-ink" data-id="element-257" data-mp="2fm36jjy8br1r">
                {buyer.name} <span className="font-normal text-ink/60" data-id="element-258" data-mp="2kmhfr5bkh71d">from {buyer.country}</span>
              </p>
              <p className="text-ink/75" data-id="element-259" data-mp="2pm3sldnhgl9n">
                just purchased <strong className="text-plum-800" data-id="element-260" data-mp="2pjhmzjk5kfu2">Implant Decision System™</strong>
              </p>
              <p className="mt-0.5 text-xs text-ink/45" data-id="element-261" data-mp="1rw8sx0635ygg">{minutes} min ago · Verified purchase</p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="absolute right-2.5 top-2.5 rounded-full p-1 text-ink/40 transition-colors duration-150 hover:text-ink" data-id="element-262" data-mp="21w9e6rnimona">
              <XIcon className="h-4 w-4" aria-hidden data-id="element-263" data-mp="195rdtye6f1dk" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}